module.exports = __webpack_public_path__ + "static/media/staff timetable.8cd82779.svg";